(function(){
  function update(el){
    const m = el.textContent.match(/\d+/);
    if(m) el.textContent = `(${m[0]})`;
  }
  function updateAll(){
    document.querySelectorAll('.reputon-reviews-count').forEach(update);
  }
  updateAll();
  const obs = new MutationObserver(muts => {
    for(const m of muts){
      for(const n of m.addedNodes){
        if(n.nodeType!==1) continue;
        if(n.matches('.reputon-reviews-count')){
          update(n);
        } else {
          n.querySelectorAll('.reputon-reviews-count').forEach(update);
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();